export const SET_DEMO_THEME = 'SET_DEMO_THEME'
export const SET_DEMO_THEME_SETTING = 'SET_DEMO_THEME_SETTING'
export const SET_DEMO_VARIABLES = 'SET_DEMO_VARIABLES'
export const SET_DEMO_ICONS = 'SET_DEMO_ICONS'
